import { ExpectedProps, ServerPropsFactory } from '@lib/factory/serverprops';
import { Modals } from '@components/Pages/ExplorePage/Modals/Modals';
import { NextPage } from 'next';
import { PageLayout } from '@components/PageLayout/PageLayout';
import React from 'react';
import cn from 'classnames';
import s from './explorePage.module.scss';
import { useTranslation } from '@hooks/useTranslation';
import { NavigationCards } from '@components/Pages/ExplorePage/NavigationCards/NavigationCards';
import { PopularCollectionsSlider } from '@components/Pages/ExplorePage/PopularCollectionsSlider/PopularCollectionsSlider';
import { PopularToysSection } from '@components/Pages/ExplorePage/PopularToysSection/PopularToysSection';
import { PopularArtistsSection } from '@components/Pages/ExplorePage/PopularArtistsSection/PopularArtistsSection';
import { PhysicalToysSection } from '@components/Pages/ExplorePage/PhysicalToysSection/PhysicalToysSection';

// Без getServerSideProps после обновления страницы удаляются квери параметры поиска
export const getServerSideProps = ServerPropsFactory(async (props: ExpectedProps) => ({
  ...props
}));
interface PageProps extends ExpectedProps {}
const Page: NextPage<PageProps> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  return <>
            <PageLayout data-sentry-element="PageLayout" data-sentry-source-file="index.tsx">
                <div className={s.explorePage}>
                    <div className={cn(s.explorePage__container, '_container')}>
                        <div className={s.explorePage__top}>
                            <div className={s.explorePage__head}>
                                <h1 className={cn(s.explorePage__title, '_title')}>
                                    {tr({
                  id: 'explore.page.title'
                })}
                                </h1>
                            </div>
                        </div>
                        <div className={s.explorePage__body}>
                            <NavigationCards data-sentry-element="NavigationCards" data-sentry-source-file="index.tsx" />
                            <PopularCollectionsSlider data-sentry-element="PopularCollectionsSlider" data-sentry-source-file="index.tsx" />
                            <PopularToysSection data-sentry-element="PopularToysSection" data-sentry-source-file="index.tsx" />
                            <PhysicalToysSection data-sentry-element="PhysicalToysSection" data-sentry-source-file="index.tsx" />
                            <PopularArtistsSection data-sentry-element="PopularArtistsSection" data-sentry-source-file="index.tsx" />
                        </div>
                    </div>
                </div>
            </PageLayout>
            <Modals data-sentry-element="Modals" data-sentry-source-file="index.tsx" />
        </>;
};
export default Page;